import { IconProps } from '../Icons.type'

export function ArrowDownSelectIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      {...props}>
      <path
        d="M4 6.5L8 10.5L12 6.5"
        stroke="#A8A8A8"
        strokeWidth="1.43"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
